import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, Typography, message, Icon, Card, Breadcrumb, DatePicker, Divider, Table, Calendar } from 'antd';
import { getStaticProRealInfo, getStaticReaInfoByMonth, reqByGet, expenditureList2, getExpenditure2, getStaticRealListByMonth, getStaticReaList, getStaticReaInfo, ExpensesBroken, ExpensesRound, getExpenditure } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import FilterForm from '@/components/form/filterForm';
import './statistical.css';
import { parse } from 'querystring';
import servers from '@/api/server'

const FormItem = Form.Item;
const Option = Select.Option;
const { Text, Title } = Typography;

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
let store_cavans, month_cavans, cost_cavans;

const filterItems = [
    {
        name: '月度时间',
        key: 'costYear',
        type: 'yearPicker',
        placeholder: '选择年度'
    }
]



class Statistic_consume extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            dataList: [],//顶级数据数组
            typeId: 0,
            timeType: 1,
            id: null,
            projectName: '实验室总经费',
            reaList: [],
            reaIds: [],
            dataSource: [],
            table_loading: false,
            contextPage: 1,
            contextRows: 5,
            costYear: '',
            pagination: {
                pageSize: 5,
                hideOnSinglePage: true,
            },
            costMothRange: [],
            // timeType: 3,
            storeRangeValue: [],
            storeRangeFormat: 'YYYY-mm',
            storeRangeMode: ['month', 'month'],
            storeRangeValue1: null,
            storeRangeValue2: null,
            storeInfo: {},
            costEcharts_flag: true,
            storeRangeOpen: false
        };
        // this.getReaList = this.getReaList.bind(this);
        this.monthTableChange = this.monthTableChange.bind(this);
        // this.getReaCost = this.getReaCost.bind(this);
        // this.realRealCostCanvas = this.realRealCostCanvas.bind(this);
        // this.costRangeChange = this.costRangeChange.bind(this)
        this.dataFilter = this.dataFilter.bind(this);
        // this.storePickTypeSelect = this.storePickTypeSelect.bind(this);
        // this.storeRangeChange = this.storeRangeChange.bind(this);
        // this.onStateChange = this.onStateChange.bind(this);
        // this.storeReaSelect = this.storeReaSelect.bind(this);
        // this.getStoreReaInfo = this.getStoreReaInfo.bind(this)
    }

    componentDidMount() {
        // document.getElementById('storeCanvas').removeAttribute('_echarts_instance_')
        store_cavans = echarts.init(document.getElementById('storeCanvas'));
        // store_cavans = echarts.init(document.getElementById("storeCanvas"), null, { renderer: 'svg' })
        // month_cavans = echarts.init(document.getElementById('realMonthCost'));
        // cost_cavans = echarts.init(document.getElementById('realCost'));
        store_cavans.showLoading();
        // month_cavans.showLoading();
        // cost_cavans.showLoading();
        // this.getReaList()
        // this.getReaCost({ type: 2 });
        // this.reaInfoByMonth({})
        // this.getMonthData({});
        // this.getStoreReaInfo(null, null, null)
        getExpenditure2(res => {
            console.log(res)
        }, err => {
            console.log(err)
            err.total.unshift({ id: 0, fundsName: '全部' })
            this.setState({
                dataList: err.total
            })
        })
        expenditureList2({}, res => {
            console.log(res);
            this.setState({
                table_loading: false
            });
            if (res.statusCode !== 1000) {
                return
            };
            const pager = { ...this.state.pagination };
            pager.total = res.size;
            // pager.total = 12;
            console.log(pager)
            this.setState({
                dataSource: res.dataList,
                pagination: pager
            })
        }, err => {
            console.log(err);
            this.setState({
                table_loading: false
            });
        })
        //圆饼图
        // ExpensesRound({ typeId: 0 }, res => {
        //     console.log(res)
        //     this.realRealCostCanvas(res)
        // })
        //折线图
        this.myExpensesBroken()
        // ExpensesBroken({ typeId: 0, timeType: 1 }, res => {//默认选择年
        //     console.log(res)
        //     this.storeCavansEcharts(res)
        // })
    }

    //修改state
    // onStateChange = (field, value) => {
    //     this.setState({
    //         [field]: value,
    //     });
    // }

    // 耗材list
    // getReaList() {
    //     const that = this;
    //     getStaticReaList({}, res => {
    //         console.log(res);
    //         if (res.statusCode !== 1000) {
    //             return
    //         };
    //         that.setState({
    //             reaList: res.reaList
    //         });
    //     }, err => {
    //         console.log(err)
    //     })
    // }


    // 获取耗材成本绘制
    // realRealCostCanvas(values) {
    //     const that = this;
    //     cost_cavans.clear();
    //     console.log(values)
    //     let datas = [];
    //     values.reaName.map((x, index) => {
    //         let ret = {};
    //         ret.value = (values.per[index] * 100).toFixed(1);
    //         ret.name = x;
    //         datas.push(ret)
    //     });
    //     cost_cavans.setOption({
    //         title: {
    //             text: '经费使用占比',
    //             // subtext: '耗材成本=耗材领用金额+损耗金额',
    //             x: 'center'
    //         },
    //         tooltip: {
    //             trigger: 'item',
    //             formatter: (params) => {
    //                 return params.seriesName + '<br/>' + params.name + ':' + params.value + '%(￥' + values.money[params.dataIndex] + ')'
    //             }
    //         },
    //         legend: {
    //             // orient: 'vertical',
    //             right: 'center',
    //             bottom: 20,
    //             data: values.reaName,
    //             formatter: function (name) {
    //                 if (name.length > 10) {
    //                     return name.substr(0, 15) + '..'
    //                 }
    //                 return name;
    //             }
    //         },
    //         series: [
    //             {
    //                 name: '经费使用占比',
    //                 type: 'pie',
    //                 radius: '55%',
    //                 center: ['50%', '50%'],
    //                 data: datas,
    //                 label: {
    //                     formatter: (params) => {
    //                         if (params.name.length > 16) {
    //                             return params.name.substr(0, 15) + '..'
    //                         };
    //                         return params.name;
    //                     }
    //                 },
    //                 itemStyle: {
    //                     emphasis: {
    //                         shadowBlur: 10,
    //                         shadowOffsetX: 0,
    //                         shadowColor: 'rgba(0, 0, 0, 0.5)'
    //                     }
    //                 }
    //             }
    //         ]
    //     });
    //     cost_cavans.on('rendered', function () {
    //         cost_cavans.hideLoading()
    //     });
    // }

    //耗材成本占比表格列表数据获取
    getMonthData(params = {}) {
        const that = this;
        that.setState({
            table_loading: true
        });
        getStaticRealListByMonth(params, res => {
            console.log(res);
            that.setState({
                table_loading: false
            });
            if (res.statusCode !== 1000) {
                return
            };
            const pager = { ...that.state.pagination };
            pager.total = res.count;
            // pager.total = 12;
            that.setState({
                dataList: res.reaList,
                pagination: pager
            })
        }, err => {
            console.log(err);
            that.setState({
                table_loading: false
            });
        })
    }

    // 删选表格
    dataFilter(values) {
        console.log(values);
        const that = this;
        let params = {
            page: 1,
            rows: that.state.contextRows,
            year: values.costYear ? values.costYear.format('YYYY') : ''
        };
        if (values.costYear) {
            that.setState({
                costYear: values.costYear.format('YYYY')
            });
        };
        const pager = { ...this.state.pagination };
        pager.current = 1;
        that.setState({
            pagination: pager,
        });
        this.getMonthData(params)
    }


    // 耗材成本占比表格分页
    monthTableChange(pagination, filters, sorter) {
        const that = this;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        console.log(sorter)
        this.setState({
            pagination: pager,
        });
        let params = {
            page: pagination.current,
            rows: that.state.contextRows,
            year: that.state.costYear
        };
        this.getMonthData(params)
    }

    //原图选择
    // handleChage = (value) => {
    //     console.log(value)
    //     let params = { typeId: 1, Id: value }
    //     ExpensesRound(params, res => {
    //         this.realRealCostCanvas(res)
    //     })
    // }
    //折线图选择
    handleChageing = (value) => {

        let name = ''
        this.state.dataList.map(el => {
            console.log(el)
            if (el.id == value) {
                name = el.fundsName
            }
        })
        console.log(value)
        console.log(name)//拿到了值
        this.setState({
            typeId: 1,
            id: value,
            projectName: name
        }, () => {
            this.myExpensesBroken()
        })
        // console.log(this.state.typeId, this.state.id, this.state.projectName)
        // this.myExpensesBroken()
        console.log(value)
        console.log(name)//拿到了值
    }
    //年份选择
    handleHear = (value) => {
        console.log(value)
        this.setState({
            timeType: value
        }, () => {
            this.myExpensesBroken()
        })
        // this.myExpensesBroken()
    }
    //调用函数
    myExpensesBroken() {
        let params = { typeId: this.state.typeId, timeType: this.state.timeType, id: this.state.id, projectName: this.state.projectName }
        console.log(params)
        reqByGet(servers.ExpensesaddBroken2, params, res => {
            console.log(res)
            if (res.statusCode !== 1000) {
                return
            }
            this.storeCavansEcharts(res)
        })
        // ExpensesBroken(params, res => {
        //     // console.log(res)
        //     this.storeCavansEcharts(res)
        // })
    }

    // 耗材备用库存占比情况开始周选择
    storeDisabledStartWeek = (startValue) => {
        const endValue = this.state.storeRangeValue2;
        if (!startValue || !endValue) {
            return false;
        };
        let weekEnd = utils.getWeekRange(endValue.format("YYYY-MM-DD"))[0];
        return startValue.valueOf() > moment(weekEnd).valueOf();
    }

    // 耗材备用库存占比情况结束周选择
    storeDisabledEndWeek = (endValue) => {
        const startValue = this.state.storeRangeValue1;
        if (!endValue || !startValue) {
            return false;
        };
        let weekStart = utils.getWeekRange(startValue.format("YYYY-MM-DD"))[1];
        return endValue.valueOf() <= moment(weekStart).valueOf();
    }



    storeCavansEcharts(values) {
        const that = this
        store_cavans.clear();
        let seriesArr = [];
        console.log(values)
        // values.reaName.map((x, index) => {
        //     let item = {};
        //     item.name = x;
        //     item.type = 'line';
        //     item.data = values['rea' + (index + 1)];
        //     seriesArr.push(item)
        // });
        // values.rea.map((x, index) => {
        let item = {};
        item.name = values.reaName;
        item.type = 'line';
        item.data = values.rea
        seriesArr.push(item)
        // });
        console.log(seriesArr)
        store_cavans.setOption({
            title: {
                text: this.state.projectName,
                top: 0,
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                formatter: params => {
                    let tip = '';
                    params.map((x, index) => {
                        if (index === 0) {
                            tip += params[0].axisValue + '<br/>';
                        }
                        tip += that.state.projectName + ':' + (parseFloat(params[index].value)).toFixed(1) + '元</span><br/>';
                    });
                    return tip
                }
            },
            legend: {
                data: values.reaName,
                top: '8%'
            },
            grid: {
                left: '12%',
                right: '4%',
                top: '24%',
                bottom: 0,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: values.time,
                axisLabel: {
                    padding: [12, 0, 18, 0]
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: (value, index) => {
                        console.log(value)
                        return ((parseFloat(value)) / 10000).toFixed(3) + '万'
                    }
                }
            },
            series: seriesArr
        }, true);
        store_cavans.hideLoading()
    }

    render() {
        const that = this;
        const { dataList } = this.state;
        return (
            <div className="statistic">
                <Card
                    bordered='flase'
                    title={
                        <div className="pr">
                            <Text strong style={{ fontSize: '15px' }}><i className="iconfont icon-anyewuleixingtongji c_8bff mr5 vm"></i>经费使用趋势图</Text>
                            <div className="pa_rm">
                                <Select
                                    // mode="multiple"
                                    // value={reaIds}
                                    // onChange={(value, option) => this.storeReaSelect(value, option)}
                                    onChange={this.handleChageing}
                                    placeholder="请选择"
                                    className="inlineBlock mr10"
                                    style={{ minWidth: '124px' }}
                                >
                                    {dataList.map(x => {
                                        return (
                                            <Option value={x.id.toString()} key={x.id} title={x.fundsName}>
                                                {x.fundsName}
                                            </Option>
                                        )
                                    })}
                                </Select>
                                <Select
                                    style={{ width: '56px' }}
                                    // value={timeType}
                                    placeholder="年"
                                    onSelect={this.storePickTypeSelect}
                                    onChange={this.handleHear}
                                    className="inlineBlock mr10"
                                >
                                    <Option key={1} value={1}>年</Option>
                                    <Option key={2} value={2}>月</Option>
                                    <Option key={3} value={3}>周</Option>
                                </Select>

                            </div>
                        </div>
                    }
                    className="statistic_panel"
                >
                    <div className="statistic_pro_tabPane" id="storeCanvas"></div>
                </Card>
            </div>
        )
    }
}


export default Statistic_consume;
